import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';
import { withModal } from 'components/modal/ModalHOC';

import TileStandardFooterHistoryModal from './modal/TileStandardFooterHistoryModal';

import { __t, applyTranslations } from 'utils/language';

import type { TileStandard } from 'types';

applyTranslations(require('../tile-standard-footer.i18n.json'));

type Props = {
  creator: TileStandard
};

const TooltipWithModal = withModal(Tooltip, {
  modalContent: TileStandardFooterHistoryModal
});

const MSG_KEY = 'tile_standard_footer';

const TileStandardFooterHistoryButton = (
  {
    creator
  }: Props
): JSX.Element => (
  <div className="tile-standard-footer-history-button">
    <TooltipWithModal
      message={__t(`${MSG_KEY}.tooltips.history`)}
      width="auto-compact"
      display="flex"
      modalContentProps={{
        influencerProfile: creator
      }}
    >
      <SVGDynamicIcon
        name="history-custom-fg"
        width={24}
        height={24}
        customColor="grey"
        clickable
      />
    </TooltipWithModal>
  </div>
);

export default TileStandardFooterHistoryButton;
